import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  static targets = ["source"]

  connect() {
    const title = this.element.dataset.tooltipTitle || "Copy"
    this.tooltip = new Tooltip(this.element, {
      title: title,
      trigger: "manual",
      placement: "top"
    })
  }

  copy() {
    const text = this.hasSourceTarget
      ? this.sourceTarget.value || this.sourceTarget.innerText
      : this.element.innerText

    navigator.clipboard.writeText(text)
      .then(() => {
        const copiedText = this.element.dataset.tooltipCopied || "Copied!"
        this.showTooltip(copiedText)
      })
      .catch(() => {
        this.showTooltip("Copy failed")
      })
  }

  showTooltip(message) {
    this.tooltip.setContent({ '.tooltip-inner': message })
    this.tooltip.show()

    clearTimeout(this.hideTimeout)
    this.hideTimeout = setTimeout(() => {
      this.tooltip.hide()
    }, 1500)
  }
}
